export class Login {
  password: string;
  userName: string;
  rememberMe: boolean;
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/models/login.ts